export const BASE_API_URL = "/api1/v1";
